import { render, staticRenderFns } from "./SpecializedCaregiver.vue?vue&type=template&id=2c149e06"
import script from "./SpecializedCaregiver.vue?vue&type=script&lang=js"
export * from "./SpecializedCaregiver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports